import { IotDeviceStateOfUse } from '@/api/generator';
import { Ref, computed } from 'vue';
import { mdiAlertOutline, mdiCircle } from '@mdi/js';

export function useDeviceConnectionState(deviceState: Ref<IotDeviceStateOfUse | undefined>) {
  return computed(() => {
    const stateInfo: Record<IotDeviceStateOfUse, { label: string; icon: string; color: string }> = {
      [IotDeviceStateOfUse.Unknown]: {
        label: 'StateOfUseEnum.Unknown',
        icon: mdiCircle,
        color: 'state-of-use-offline',
      },
      [IotDeviceStateOfUse.Offline]: {
        label: 'StateOfUseEnum.Offline',
        icon: mdiCircle,
        color: 'offline',
      },
      [IotDeviceStateOfUse.Initializing]: {
        label: 'StateOfUseEnum.Initializing',
        icon: mdiCircle,
        color: 'success',
      },
      [IotDeviceStateOfUse.Measuring]: {
        label: 'StateOfUseEnum.Measuring',
        icon: mdiCircle,
        color: 'success',
      },
      [IotDeviceStateOfUse.DeviceError]: {
        label: 'StateOfUseEnum.DeviceError',
        icon: mdiAlertOutline,
        color: 'error',
      },
      [IotDeviceStateOfUse.Online]: {
        label: 'StateOfUseEnum.Online',
        icon: mdiCircle,
        color: 'success',
      },
    };

    return stateInfo[deviceState.value ?? IotDeviceStateOfUse.Unknown];
  });
}
